import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {environment} from '../../../containers/environment';
import { check, findUsersById } from "../../Services/UsersService";
import { findAllHistory, findAllHistoryByUser } from "../../Services/HistoryService";
import ProfileMain from './components/ProfileMain';
import ProfileCalendar from './components/ProfileCalendar';
import ProfileTabs from './components/ProfileTabs';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class Calendar extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      user: {},
      histories: []
    };
    check();
  }

  loadUser(user){
    findUsersById(user.id)
      .then(data => {
        if(data === undefined){
          data = {};
        }
        if(data !== undefined && data.error === undefined){
          this.setState({ user: data });
        } else {
          if(data.errors === undefined){
            data = {};
            this.show('danger', this.props.t('forms.errorLoadData'));
          } else {
            data = {};
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
    });
  }

  loadHistory(user){
    if(environment.isAdmin()){
      this.loadHistoryByUser("admin", user);
    }else{
      this.loadHistoryByUser("user", user);
    }
  }

  loadHistoryByUser(role, user){
    if(role === "admin"){
      let data = [];
      this.setState({ histories: data });
      findAllHistory()
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          this.setState({ histories: data });
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorLoadDataOrders'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }else{
      findAllHistoryByUser(user.id)
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          this.setState({ histories: data });
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorLoadDataOrders'))
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage)
          }
        }
      });
    }
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    let user = environment.getUser();
    this.loadUser(user);
    this.loadHistory(user);
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    return (
      <div className="containerInside__wrap">
        <Container>
          <div className="profile">
            <Row>
              <Col md={12} lg={12} xl={6}>
                <Row>
                  <ProfileMain user={this.state.user} />
                  <ProfileCalendar />
                </Row>
              </Col>
              <ProfileTabs user={this.state.user} histories={this.state.histories} />
            </Row>
          </div>
        </Container>
      </div>
    );
  }
}

export default reduxForm({
  form: 'calendar_form_edit', // a unique identifier for this form
})(withTranslation('common')(Calendar));
